module.exports = __webpack_public_path__ + "media/images/icons/flags/MG-6ed75f6dfdda05034add08317cc106bf.svg";